module.exports = __webpack_public_path__ + "static/media/stack-ring_720x480.da9bf6ad.jpg";